<template lang="pug">
  .advanced-options-wrapper
    PSelect(v-if="opcoesAvancadas" title="opções" labelItem="name" v-model="opcoesAvancadas" :allowEmpty="false")

    PButton(size="md" block color="success" @click="save" :loading="saving") Salvar

</template>

<script>
export default {
  name: 'AdvancedOptions',
  props: {
    saveParams: {type: Object, required: true},
    options: {type: Array, required: true}
  },
  created () {
    this.optionsData.items = this.options
    this.optionsData.selected = this.options[0]
  },
  mounted () {
    this.opcoesAvancadas = {
      loaded: [...this.options],
      selected: null
    }
  },
  data () {
    return {
      saving: false,
      optionsData: {
        selected: null,
        items: []
      },
      opcoesAvancadas: null
    }
  },
  methods: {
    async save (option) {
      this.saving = true

      try {
        const result = await this.$API.fastRegister.save({
          ...this.saveParams,
          option: this.optionsData.selected.id,
          extra: {}
        })
        this.$checkUserFiles()
        this.$swalSucesso(result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso')
      } catch (e) {
        this.$swalErro(e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças')
      }

      this.saving = false
    },
    onSelectOption (item) {
      this.optionsData.selected = item
    }
  }
}
</script>

<style scoped lang="scss">
.advanced-options-wrapper {
  display: grid;
  grid-column-gap: 30px;
}
</style>
